var _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 32L40 15L66 32",
    stroke: "#B7BDCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00006 36.0001C4.00003 33.2386 6.23862 31 9.00006 31H71C73.7614 31 76 33.2386 76 36V66C76 68.7614 73.7614 71 71 71H9.00045C6.23905 71 4.00049 68.7615 4.00045 66.0001L4.00006 36.0001Z",
    fill: "#C1CCF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25004 36C6.25002 34.4812 7.48124 33.25 9.00004 33.25H71C72.5188 33.25 73.75 34.4812 73.75 36V66C73.75 67.5188 72.5188 68.75 71 68.75H9.00045C7.48168 68.75 6.25047 67.5188 6.25045 66L6.25004 36Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2888 55.694H19.4248L19.2048 53.252L25.5848 43.286L27.9388 44.716L22.5048 53.252H26.2888V49.204H29.1048V53.252H30.9088V55.694H29.1048V59.61H26.2888V55.694ZM40.0189 57.256C41.3389 57.256 42.3802 56.7427 43.1429 55.716C43.9202 54.6893 44.3089 53.296 44.3089 51.536C44.3089 49.776 43.9202 48.3827 43.1429 47.356C42.3802 46.3293 41.3389 45.816 40.0189 45.816C38.6842 45.816 37.6282 46.3293 36.8509 47.356C36.0736 48.3827 35.6849 49.776 35.6849 51.536C35.6849 53.296 36.0736 54.6893 36.8509 55.716C37.6282 56.7427 38.6842 57.256 40.0189 57.256ZM32.8469 51.536C32.8469 49.864 33.1402 48.412 33.7269 47.18C34.3136 45.948 35.1422 45.002 36.2129 44.342C37.2982 43.6673 38.5669 43.33 40.0189 43.33C41.4709 43.33 42.7322 43.6673 43.8029 44.342C44.8736 45.002 45.6949 45.948 46.2669 47.18C46.8536 48.412 47.1469 49.864 47.1469 51.536C47.1469 53.208 46.8536 54.66 46.2669 55.892C45.6949 57.124 44.8736 58.0773 43.8029 58.752C42.7322 59.412 41.4709 59.742 40.0189 59.742C38.5669 59.742 37.2982 59.412 36.2129 58.752C35.1422 58.0773 34.3136 57.124 33.7269 55.892C33.1402 54.66 32.8469 53.208 32.8469 51.536ZM56.1951 55.694H49.3311L49.1111 53.252L55.4911 43.286L57.8451 44.716L52.4111 53.252H56.1951V49.204H59.0111V53.252H60.8151V55.694H59.0111V59.61H56.1951V55.694Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 15,
    r: 3,
    fill: "#111B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.8a08e120ee84063a04f3af816e690d94.svg";
export { ForwardRef as ReactComponent };